/* eslint-disable @typescript-eslint/no-this-alias */
import React, { useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import BillingAddressCardSelect from './BillingAddressCardSelect.jsx';

const BillingAddressSelectCongress = (props) => {
    const {
        connected_as,
        membres_id,
        defaultValue
    } = props;

    const [billingAddresses, setBillingAddresses] = useState([]);
    const [addressSelected, setAddressSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        fetch(ENV.base_lang_url + "account/ajax_billing_address/get_current_membres_id")
            .then(res => res.json())
            .then(
                (result) => {
                    fetch(ENV.base_lang_url + "account/ajax_billing_address/get_list/null/" + membres_id)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                setIsLoading(false);
                                setBillingAddresses(result.billingAddresses);
                                setAddressSelected(defaultValue != '' ? defaultValue : null);
                            },
                            (error) => {
                                nav.infos_error("An error has occurred while loading data. Please reload the page.");
                            }
                        )
                }
            )

    }, [])

    useEffect(() => {
        if (defaultValue > 0 && addressSelected == null) {
            setSelected(defaultValue)
        }       
    }, [addressSelected])

    const setSelected = id => {
        setAddressSelected(id)
    }

    return (isLoading ?
        <div className="row">
            <div className="billing-address-card col-12 col-md-6 mb-3">
                <Skeleton className="card" variant="rectangular" width="100%" height={360} />
            </div>
        </div>        
        :
        <div className="row">
            {billingAddresses.length > 0 ?
                billingAddresses.map((e, index) =>
                <BillingAddressCardSelect
                    id={e.id}
                    key={index}
                    cardTitle={e.name}
                    businessName={e.business_name}
                    lastName={e.business_holder_last_name}
                    firstName={e.business_holder_first_name}
                    address={e.business_address}
                    postalCode={e.business_postal_code}
                    city={e.business_city}
                    country={e.title}
                    taxId={e.business_tax_id}
                    isDefault={e.is_default}
                    isSelected={(e.id == addressSelected || e.selected) ? 1 : 0}
                    onDefineAsSelected={setSelected}
                    editable={e.editable ?? true}
                />)
                :
                <div className="col-12 col-md-6 mb-3">
                    <a
                        href="#"
                        data-target={connected_as+"//account/billing_address_add/" + membres_id}
                        data-part="+"
                        className="billing-address-card bg-light border border-light rounded d-flex align-items-center justify-content-around get_part_link js-nav"
                        style={{width: '100%', height: '360px'}}
                    >
                        <span className="text-gc-orange font-weight-bold">
                            <i className="fas fa-plus mr-1"></i>
                            {'add_billing_address'.trad()}
                        </span>
                    </a>
                </div>
            }

            <input
                type="hidden"
                className="invisible position-absolute"
                name="payment_informations_id" 
                value={addressSelected ?? ''}
            />
        </div>
    )
}

export default BillingAddressSelectCongress;

BillingAddressSelectCongress.defaultProps = {
    defaultValue: null,
    membres_id: 0,
    connected_as: 'providers'
};